import { FeatureFlags } from '@/modules/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsAdminAiAssistantAvailable = (): boolean =>
  useFeatureFlag(FeatureFlags.ADMIN_AI_ASSISTANT);
